import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ParsedGraphQLError {
  message: string;
  path?: string;
  type?: string;
  code?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GraphQLErrorService {
  private errorsSubject = new BehaviorSubject<ParsedGraphQLError[]>([]);
  public readonly errors$: Observable<ParsedGraphQLError[]> = this.errorsSubject.asObservable();

  reportErrors(errors: ParsedGraphQLError[]) {
    this.errorsSubject.next(errors);
  }

  clearErrors() {
    this.errorsSubject.next([]);
  }
}
